import {
  BaseDTO,
} from 'shared';

export class DonationBillsDTO extends BaseDTO {
  id?: number;

  balance: number;

  end: Date;

  email: string;

  grossRevenue: number;

  status: BillStatus;

  kashfPercentage: number;

  netRevenue: number;

  type: string;
}

export enum BillStatus {
  NOT_SETTLED = 'NotSettled',
  SETTLED = 'Settled',
}

export class SettlementDTO extends BaseDTO {
  date: Date;

  transactionId: string;

  billId: number;

  receipt: string;

  bankName: string;
}
